import type { FC } from "react";

import { GiftIcon } from "@jti/brand-icons/gift";
import { Button } from "@jti/core-components/components/Button";
import { useDeviceBreakpoint } from "@jti/ui/hooks/useDeviceBreakpoint";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import styles from "./DelayedLotteryConfirmation.module.scss";

export type DelayedLotteryConfirmationProps = {
  rewardTitle: string;
  onExploreMoreRewards?: () => void;
};

export const DelayedLotteryConfirmation: FC<DelayedLotteryConfirmationProps> = ({
  rewardTitle,
  onExploreMoreRewards,
}) => {
  const { breakpoint } = useDeviceBreakpoint();
  const isSmallScreen = breakpoint === "mobile";
  const { __ } = useTranslations();

  return (
    <div className={styles.delayedLotteryConfirmation}>
      <span className={styles.prizeName}>{rewardTitle}</span>
      <div className={styles.textSectionWrapper}>
        <GiftIcon className={styles.giftIcon} />
        <span className={styles.textSectionTitle}>
          {__("loyalty.redeemDialog.delayed-lottery-physical.confirmation")}
        </span>
      </div>
      <p className={styles.description}>{__("loyalty.redeemDialog.delayed-lottery-physical.description")}</p>
      <Button
        variant="secondary"
        onClick={onExploreMoreRewards}
        size={isSmallScreen ? "sm" : "md"}
        className={styles.button}
      >
        {__("loyalty.redeemDialog.exploreMoreRewardsButtonText")}
      </Button>
    </div>
  );
};
